import DaneaGrey from "assets/danea-grey.png";

export const Footer = () => (
  <footer className="container-fluid p-0 py-3 mt-auto d-print-none bg-dark">
    <div className="container">
      <div className="row text-center">
        <div className="col-12 d-flex align-items-center justify-content-center pb-4">
          <a href="//www.danea.it" target="_blank" rel="noreferrer">
            <img alt="Danea logo" src={DaneaGrey} width={146} height={49} />
          </a>
        </div>
        <div className="col-12 d-flex align-items-center justify-content-center">
          <h6 className="text-light fw-light">
            Danea Transfer è un servizio&nbsp;
            <a
              className="text-light"
              href="https://www.teamsystem.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              TeamSystem S.p.A.
            </a>
            <br /> P.Iva 01035310414
          </h6>
        </div>

        <div className="col-12 d-flex align-items-center justify-content-center">
          <div className="d-inline-flex gap-2 align-items-center me-3">
            <a
              className="text-light"
              href="https://www.danea.it/privacy-policy-danea/"
              target="_blank"
              rel="noreferrer"
            >
              Privacy
            </a>
          </div>
          <div className="d-inline-flex gap-2 align-items-center me-3">
            <a
              className="text-light"
              href="https://www.danea.it/azienda/chi-siamo/"
              target="_blank"
              rel="noreferrer"
            >
              Chi siamo
            </a>
          </div>
          <div className="d-inline-flex gap-2 align-items-center me-3">
            <a
              className="text-light"
              href="https://www.facebook.com/DaneaSoft/"
              target="_blank"
              rel="noreferrer"
            >
              Facebook
            </a>
          </div>
        </div>
      </div>
    </div>
  </footer>
);

